import {IState} from './model'

export const selectToken = ({login}: {login: IState}) => login.token



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/login/selectors.ts